<svg
  aria-hidden="true"
  class="h-full w-full"
  fill="none"
  preserveAspectRatio="xMidYMid slice"
  viewBox="0 0 1634 342"
  xmlns="http://www.w3.org/2000/svg">
  <mask height="342" id="mask0_7352_16421" maskUnits="userSpaceOnUse" style="mask-type: alpha" width="1634" x="0" y="0">
    <rect fill="url(#paint0_linear_7352_16421)" height="342" width="1634" />
  </mask>
  <g mask="url(#mask0_7352_16421)">
    <g>
      <path
        d="M588.208 -608.328C406.584 -656.793 171.404 -344.453 141.374 -304.57C-15.2626 -96.5431 -140.693 235.989 -38.4476 492.111C32.4336 669.668 208.111 798.923 293.759 746.105C372.746 697.394 303.979 537.731 420.262 314.307C522.293 118.27 636.482 123.509 709.712 -40.9555C803.952 -252.605 750.136 -565.119 588.208 -608.328Z"
        fill="url(#paint1_radial_7352_16421)" />
    </g>
    <g>
      <path
        d="M901.311 196.752C777.314 78.7759 638.436 44.0087 591.589 32.8961C349.231 -24.6146 156.185 80.7124 -65.6687 169.629C-239.694 239.38 -416.461 336.056 -505.961 500.839C-507.189 503.099 -509.009 506.401 -511.441 511.107C-590.835 664.908 -594.052 887.407 -513.759 967.943C-367.341 1114.8 1.5594 734.158 317.874 887.216C532.041 990.849 536.48 1249.33 706.932 1246.79C800.124 1245.4 944.974 1166.37 1029.32 1051.02C1032.15 1047.16 1034.01 1044.52 1034.84 1043.39C1214.85 796.163 1119.36 404.22 901.312 196.758L901.311 196.752Z"
        fill="url(#paint2_radial_7352_16421)" />
    </g>
    <g>
      <path
        d="M215.733 116.244C292.287 230.62 409.454 282.723 449.176 299.821C654.668 388.284 867.125 340.779 1100.93 311.254C1284.32 288.099 1478.95 244.42 1614.87 131.891C1616.74 130.348 1619.49 128.097 1623.25 124.862C1746.29 19.0891 1821.08 -154.001 1772.84 -231.29C1684.88 -372.241 1220.98 -141.457 977.956 -317.79C813.411 -437.182 892.731 -639.73 734.336 -668.392C647.735 -684.064 488.317 -648.416 373.103 -573.547C369.246 -571.039 366.668 -569.314 365.542 -568.579C119.331 -407.975 81.1108 -84.8819 215.728 116.248L215.733 116.244Z"
        fill="url(#paint3_radial_7352_16421)" />
    </g>
    <g>
      <path
        d="M297.705 -28.2413C284.285 56.5137 309.448 123.741 318.19 146.244C363.409 262.664 461.818 312.4 561.649 378.698C639.959 430.703 730.165 476.179 823.655 466.252C824.937 466.116 826.818 465.928 829.453 465.593C915.534 454.617 1008.3 392.648 1018.7 336.587C1037.66 234.36 775.563 190.343 748.744 16.2082C730.587 -101.694 836.027 -177.06 786.48 -246.71C759.391 -284.79 685.551 -322.11 613.933 -324.118C611.534 -324.184 609.915 -324.202 609.212 -324.223C455.935 -328.211 321.308 -177.284 297.707 -28.2434L297.705 -28.2413Z"
        fill="url(#paint4_radial_7352_16421)" />
    </g>
  </g>
  <defs>
    <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_7352_16421" x1="817" x2="817" y1="0" y2="342">
      <stop />
      <stop offset="1" stop-opacity="0" />
    </linearGradient>
    <radialGradient
      cx="0"
      cy="0"
      gradientTransform="matrix(282.841 -651.979 561.449 198.331 107.811 -256.263)"
      gradientUnits="userSpaceOnUse"
      id="paint1_radial_7352_16421"
      r="1">
      <stop stop-color="#FBCFE5" />
      <stop offset="1" stop-color="#F1A9CB" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      cx="0"
      cy="0"
      gradientTransform="matrix(842.267 67.2411 67.1381 -842.544 311.811 896.199)"
      gradientUnits="userSpaceOnUse"
      id="paint2_radial_7352_16421"
      r="1">
      <stop stop-color="#84CAFF" />
      <stop offset="1" stop-color="#BEDAF3" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      cx="0"
      cy="0"
      gradientTransform="translate(966.814 -337.123) rotate(53.1908) scale(778.91 778.756)"
      gradientUnits="userSpaceOnUse"
      id="paint3_radial_7352_16421"
      r="1">
      <stop stop-color="#84CAFF" />
      <stop offset="1" stop-color="#BEDAF3" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      cx="0"
      cy="0"
      gradientTransform="matrix(177.732 448.67 448.74 -177.806 751.35 -166.033)"
      gradientUnits="userSpaceOnUse"
      id="paint4_radial_7352_16421"
      r="1">
      <stop stop-color="#84CAFF" />
      <stop offset="1" stop-color="#BEDAF3" stop-opacity="0" />
    </radialGradient>
  </defs>
</svg>
